/**
 * SiteFooter — the legal links on every page.
 *
 * "Términos de Servicio · Política de Privacidad · Contacto", rendered once from
 * AppRouter under every route (the landing page carries its own footer with the same
 * three links and the logo lockup, so it is skipped there).
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';

export const FOOTER_LINKS = {
  en: [
    { to: '/terms', label: 'Terms of Service' },
    { to: '/privacy', label: 'Privacy Policy' },
    { to: '/contact', label: 'Contact' },
  ],
  es: [
    { to: '/terms', label: 'Términos de Servicio' },
    { to: '/privacy', label: 'Política de Privacidad' },
    { to: '/contact', label: 'Contacto' },
  ],
};

const SiteFooter = () => {
  const { lang } = useTranslation();
  const links = FOOTER_LINKS[lang === 'es' ? 'es' : 'en'];
  return (
    <footer className="border-t border-slate-200 bg-slate-50" data-testid="site-footer">
      <div className="container mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-500">
        <nav className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1" aria-label="Legal">
          {links.map((l, i) => (
            <React.Fragment key={l.to}>
              {i > 0 && <span aria-hidden="true">{' · '}</span>}
              <Link to={l.to} className="hover:text-slate-900 transition-colors" data-testid={`footer-link-${l.to.slice(1)}`}>
                {l.label}
              </Link>
            </React.Fragment>
          ))}
        </nav>
        <div>© {new Date().getFullYear()} CHEKSTE · Digital Solutions Consulting LLC</div>
      </div>
    </footer>
  );
};

export default SiteFooter;
